<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1,1,1)" @submit.native.prevent label-width="80px">
            <el-form-item label="关键字：" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20"
                          placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1,1,1)" size="small" icon="el-icon-search">查询
                </el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-show="pageType=='myNode'" v-if="hasPermission(`academic:point:${pageType}:add`)"
                           type="primary" @click="addNode('view')"
                           size="small">新增
                </el-button>
                <el-button v-show="pageType=='myNode'" v-if="hasPermission(`academic:point:${pageType}:import`)"
                           type="primary" @click="importData()"
                           size="small">导入
                </el-button>
                <el-button v-if="hasPermission(`academic:point:${pageType}:export`)" type="primary"
                           @click="exportData()"
                           size="small">导出
                </el-button>
                <el-button v-show="pageType=='myNode'" v-if="hasPermission(`academic:point:${pageType}:deletes`)"
                           type="primary"
                           @click="deleteData()" size="small">删除
                </el-button>
            </el-form-item>
        </el-form>
        <div class="dataBox">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" height="100%"
                    class="table" border
                    ref="multipleTable"
                    :row-key="'id'"
                    @sort-change="sortChange"
                    @selection-change="selectionChangeHandle"
            >
                <el-table-column :reserve-selection="true" type="selection" width="50"/>
                <el-table-column prop="knowledgeName" label="节点名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="knowledgeSource" label="来源" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="pageType=='myNode'" prop="knowledgeState" label="状态"
                                 show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-switch
                                v-model="row.knowledgeState"
                                active-value="1"
                                @change="setType(row)"
                                inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateByName" label="最新修改人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" label="最新修改时间" sortable
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" label="创建时间" sortable show-overflow-tooltip></el-table-column>
                <el-table-column v-if="pageType=='myNode'" fixed="right" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission(`academic:point:${pageType}:edit`)" type="text" size="small"
                                   @click="addNode('edit',row)">编辑
                        </el-button>
                        <el-button v-if="hasPermission(`academic:point:${pageType}:deletes`)" type="text"
                                   size="small" @click="deleteData(row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-node ref="addNode" @refresh="refreshList(1,1,1)"></add-node>
        <ImportData ref="importData" @refreshData="refreshList()"></ImportData>
    </div>
</template>

<script>

import AddNode from "@/views/modules/academic/point/addNode.vue";
import ImportData from "@/views/modules/academic/point/importData.vue";

export default {
    name: "myNode",
    components: {ImportData, AddNode},
    props: {
        pageType: {
            type: String,
            default: 'myNode',
        },
    },
    data() {
        return {
            searchForm: {
                keyword: '',
                current: 1,
                size: 20,
            },
            total: 0,

            loading: false,
            dataList: [],
            dataListSelect: [],
            newSearchData: {},
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect, sort) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (sort) {
                this.$refs.multipleTable.clearSort()
            }
            this.loading = true
            let fechUrl = ''
            if (this.pageType == 'nodeManage') {
                fechUrl = this.api.academic.knowledgenodeManageList
            } else {
                fechUrl = this.api.academic.knowledgenodeList
            }
            this.newSearchData = this.searchForm
            this.$axios(fechUrl, this.searchForm).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1, 1)
        },

        // 列表排序
        sortChange(column, type) {
            // sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
            console.log(column)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //切换状态
        setType(row) {
            row.knowledgeState = row.knowledgeState == 1 ? 0 : 1
            this.$axios(this.api.academic.knowledgenodeUpdateById, {
                id: row.id,
                knowledgeState: row.knowledgeState == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                    this.refreshList('', 1)
                }
            })
        },

        //type view新增 edit编辑
        addNode(type, row) {
            this.$refs.addNode.init(type, row)
        },

        //导入
        importData() {
            this.$refs.importData.init()
        },

        //导出
        exportData() {
            if (this.total == 0) {
                this.$message.warning('暂无可导出的数据!')
                return
            }
            let ids = this.dataListSelect.map(item => {
                return item.id
            })
            let fechUrl = ''
            let fileName = ''
            if (this.pageType == 'nodeManage') {
                fechUrl = this.api.academic.knowledgenodeExportCentre
                fileName = '节点管理'
            } else {
                fechUrl = this.api.academic.knowledgenodeExport
                fileName = '我的节点'
            }
            this.exportExcel(fechUrl, {
                ids,
                ...this.newSearchData,
            }, fileName, 'post')
        },

        //删除
        deleteData(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            let ids = list.map(item => {
                if (item.knowledgeState == 1) {
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.knowledgenodeRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
    }
}
</script>

<style scoped>

</style>
